import React from 'react';
import { connect } from 'react-redux';
import Typography from '@material-ui/core/Typography';
import getVisibleEntries from '../../selectors/entries';
import { selectEntryTotal, formattedEntriesTotal, entryTypeBalance, positiveNumber } from '../../selectors/entriesTotal';

export const EntriesFooter = ({ entryCount, entriesTotal, visibleEntries }) => {
  const entryOrEntries = entryCount === 1 ? 'entry' : 'entries';
  return (
    <div className="test">
      <Typography variant="subheading" align="right" color={positiveNumber(entryTypeBalance(visibleEntries, "cash_in")) ? 'primary' : 'secondary'}>
        Cash In {formattedEntriesTotal(entryTypeBalance(visibleEntries, "cash_in"))}
      </Typography>
      <Typography variant="subheading" align="right" color={positiveNumber(entryTypeBalance(visibleEntries, "disbursement")) ? 'primary' : 'secondary'}>
        Disbursement {formattedEntriesTotal(entryTypeBalance(visibleEntries, "disbursement"))}
      </Typography>
      <Typography variant="subheading" align="right" color={positiveNumber(entryTypeBalance(visibleEntries, "hand_in")) ? 'primary' : 'secondary'}>
        Hand In {formattedEntriesTotal(entryTypeBalance(visibleEntries, "hand_in"))}
      </Typography>
      <Typography variant="subheading" align="right" color={positiveNumber(entriesTotal) ? 'primary' : 'secondary'}>
        Viewing {entryCount} {entryOrEntries} totaling {formattedEntriesTotal(entriesTotal)}
      </Typography>
    </div>
  );
};

const mapStateToProps = ({ filters, entries }) => {
  const visibleEntries = getVisibleEntries(entries
  , filters);
  return {
    entryCount: visibleEntries.length,
    entriesTotal: selectEntryTotal(visibleEntries) / 100,
    visibleEntries
  };
};

export default connect(mapStateToProps)(EntriesFooter);



// WEBPACK FOOTER //
// ./src/components/entries/EntriesFooter.js